import { FC, MouseEvent, memo, useState } from 'react';

import { useRouteRef } from '@backstage/core-plugin-api';
import {
  createStyles,
  IconButton,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Menu,
  MenuItem,
} from '@material-ui/core';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import BubbleChartIcon from '@material-ui/icons/BubbleChart';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import WebAssetIcon from '@material-ui/icons/WebAsset';
import clsx from 'clsx';
import { dataProductRouteRef } from '../../../routes';
import { DataProductPageRoutes } from '../../DataProductPage/DataProductPageRoutes';
import { Link } from 'react-router-dom';

type SearchSystemActionsMenuProps = {
  dataProductId: string;
  inDataContractLineage?: boolean;
  size?: 'small' | 'medium';
};

const useStyles = makeStyles(
  theme =>
    createStyles({
      actionsMenuButton: {
        padding: theme.spacing(0.5),
        minWidth: '30px',
      },
    }),
  { name: 'SearchSystemActionsMenu' },
);

export const SearchSystemActionsMenu: FC<SearchSystemActionsMenuProps> = memo(
  ({ dataProductId, inDataContractLineage, size = 'medium' }) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      event.stopPropagation();
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const dataProductRoute = useRouteRef(dataProductRouteRef)({
      id: `${dataProductId}`,
    });

    const dependenciesRoute = `${dataProductRoute}${DataProductPageRoutes.RELATIONS_ROUTE}`;

    const dataContractsRoute = `${dataProductRoute}${DataProductPageRoutes.DATA_CONTRACTS_LINEAGE}`;

    return (
      <>
        <IconButton
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          aria-label={open ? 'close' : 'more'}
          onClick={handleClick}
          className={clsx(classes.actionsMenuButton)}
          color="secondary"
        >
          <MoreVertIcon fontSize={size} />
        </IconButton>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          onClick={e => {
            e.stopPropagation();
          }}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <MenuItem component={Link} to={dataProductRoute}>
            <ListItemIcon>
              <WebAssetIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Overview" />
          </MenuItem>
          <MenuItem component={Link} to={dependenciesRoute}>
            <ListItemIcon>
              <BubbleChartIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Lineage" />
          </MenuItem>
          {inDataContractLineage && (
            <MenuItem component={Link} to={dataContractsRoute}>
              <ListItemIcon>
                <AccountTreeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Data Contracts" />
            </MenuItem>
          )}
        </Menu>
      </>
    );
  },
);
